import {PROJECT_MANAGER_AND_ABOVE_ROLES} from './permissions';

export const CONTRACT_CREATE_ROLES = PROJECT_MANAGER_AND_ABOVE_ROLES;

export const CONTRACT_EDIT_ROLES = CONTRACT_CREATE_ROLES;
